import format from "date-fns/format";
import getQuarter from "date-fns/getQuarter";

/**
 * Will return a string of the date formatted in specified format
 * tests if the date is a js Date object, or a string
 * NOT for use with times - discards the timestamp part of the date if there
 *
 * some common formats yy - 21, yyyy - 2021, yyy-2021
 * dd - 03, d- 3
 * MM - 04, M - 4, MMM - Apr, MMMM - April
 *
 * formatting docs - https://date-fns.org/v2.19.0/docs/format
 *
 * @param {string/Date} date
 * @param {string} formatting
 * @returns
 */
export function formatDate(date, formatting = "MM/dd/yy") {
  if (!date) return "";
  if (typeof date === "string") {
    date = dateAdjustedForTimezone(date);
  }

  if (typeof date?.getMonth === "function") {
    return format(date, formatting);
  }

  return "";
}

/** will take a date string input, and return a
 * JS Date object that is adjusted to remove the locale timezone
 * useful for the datepicker, which always displays the local date
 */
export function dateAdjustedForTimezone(datestring) {
  if (!datestring) return "";
  if (typeof datestring !== "string") return datestring;

  //discard the timestamp part of the date if there
  datestring = datestring.split("T")[0];
  return new Date(`${datestring}T00:00`);
}

/**
 *
 * @param {int} startYear
 * @param {int} endYear
 */
export function getQuartersByYearRange(startYear = 2020, endYear = null) {
  //console.log(startYear, endYear);
  if (!Number.isInteger(startYear)) return [];
  if (endYear && !Number.isInteger(endYear)) {
    return [];
  }

  if (!endYear) {
    return getQuartersByYear(startYear);
  }

  let result = [];
  for (
    let i = startYear;
    endYear > startYear ? i <= endYear : i >= endYear;
    endYear > startYear ? i++ : i--
  ) {
    result = result.concat(getQuartersByYear(i));
  }
  return result;
}

export function getQuartersByYear(year) {
  if (!Number.isInteger(year)) return [];
  return [
    {
      startDate: `${year}-01-01`,
      endDate: `${year}-03-31`,
      display: `Q1 ${year}`
    },
    {
      startDate: `${year}-04-01`,
      endDate: `${year}-06-30`,
      display: `Q2 ${year}`
    },
    {
      startDate: `${year}-07-01`,
      endDate: `${year}-09-30`,
      display: `Q3 ${year}`
    },
    {
      startDate: `${year}-10-01`,
      endDate: `${year}-12-31`,
      display: `Q4 ${year}`
    }
  ];
}

/**
 * will return the string representation of the quarter
 * the provided date falls in, ie. "Q2 2021"
 * if no input is provided, will return the current date's quarter
 * @param {string} date
 */
export function getQuarterFromDate(date = null) {
  date = dateAdjustedForTimezone(date) || new Date();
  const quarter = getQuarter(date);
  return `Q${quarter} ${date.getFullYear()}`;
}

export const dateIsInPast = date => {
  const today = new Date();
  const inputDate = new Date(date);
  return inputDate < today;
};
